<script lang="ts">
  import {
    ScrollerVideo,
    Block,
    ScrollerBase,
    ScrollerVideoForeground,
    Headline,
  } from '@reuters-graphics/graphics-components';

  import { assets } from '$app/paths';
  let progress = $state(0);
  let width = $state(0);

  let { content, embedded = false } = $props();
  // let windowWidth = $state(0);
  // let desktopVideo = $state(`${assets}/videos/final.mp4`);
  // let mobileVideo = $state(`${assets}/videos/phone_final.mp4`);
  //   let foregrounds = content.blocks[0].foregrounds;
  let block = content.blocks[0];
  let windowWidth = $state(0);
  let desktopVideo = $state(`${assets}/videos/final.mp4`);
  let mobileVideo = $state(`${assets}/videos/phone_final.mp4`);
  if (typeof window !== 'undefined') {
    windowWidth = window.innerWidth;
  }
  function stripHtmlTags(str) {
    return str.replace(/<[^>]*>/g, '');
  }
</script>

<!-- <Block width="fluid" id="header-group">
  <ScrollerVideo
    src={`${assets}/videos/final.mp4`}
    height={block.height}
    class=""
    objectFit="cover"
    sticky={true}
    full={true}
    trackScroll={true}
    lockScroll={true}
    useWebCodecs={false}
    debug={false}
    showDebugInfo={false}
    autoplay={false}
    embedded={false}
    transitionSpeed={8}
    frameThreshold={undefined}
    videoPercentage={undefined}
    onReady={() => {}}
    onChange={() => {}}
    embeddedProps={{
      threshold: 0.5,
      duration: undefined,
      delay: 200,
    }}
  >
    <ScrollerVideoForeground id="head-scroller" startTime={0} endTime={0.15}>
      <Headline
        hed={content.hed}
        dek={content.dek}
        authors={content.authors}
        class="headlineTop"
        publishTime={content.publishTime}
        updateTime={content.updateTime}
      />
    </ScrollerVideoForeground>

    {#each block.foregrounds as foreground}
      <ScrollerVideoForeground
        startTime={parseFloat(foreground.startTime)}
        endTime={parseFloat(foreground.endTime)}
        position={foreground.position}
        backgroundColour={foreground.backgroundColour}
        text={foreground.text}
      />
    {/each}
  </ScrollerVideo>
</Block> -->

<ScrollerBase bind:progress query="div.step-foreground-container">
  {#snippet backgroundSnippet()}
    <ScrollerVideo
      src={windowWidth < 610 ? mobileVideo : desktopVideo}
      videoPercentage={progress}
      trackScroll={false}
      height="100lvh"
    />
  {/snippet}
  {#snippet foregroundSnippet()}
    {#each block.foregrounds as foreground}
      <div class="step-foreground-container {foreground.cls}">
        <div class="scroller-text-content">
          <h3>{foreground.subhead}</h3>
          <p>{@html foreground.text}</p>
        </div>
      </div>
    {/each}
  {/snippet}
</ScrollerBase>

<style lang="scss">
  .step-foreground-container {
    height: 100lvh;
    width: 100%;
    max-width: 500px;
    position: relative;
    // border: 2px solid red;

    margin: auto;

    h3 {
      text-align: center;
      font-family: var(--theme-font-family-sans-serif);
      font-weight: 700;
      font-size: calc(var(--theme-font-size-lg));
      display: flex;
      margin-top: 0px;
      align-items: center;
      justify-content: center;
    }

    @media (max-width: 500px) {
      padding: 0px 10px;
    }
  }
  .step-foreground-container.caption1 {
    margin-top: -20lvh;

    p {
      text-align: center;
    }
  }
  .step-foreground-container.caption3,
  .step-foreground-container.caption4 {
    height: 80lvh;
  }
  .step-foreground-container:last-child {
    // height: 150lvh;
    // border: 2px solid red;
  }
  .step-foreground-container.caption6 {
    // opacity: 0;
  }
  .step-foreground-container.caption7 {
    // padding-top: 50lvh;
    // padding-bottom: 100lvh;
  }

  .scroller-text-content {
    background-color: rgba(239, 249, 251, 0.8);
    padding: 1rem;
    border-radius: 8px;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    p {
      margin: 0;
      padding: 0;
    }

    span.blue {
      color: #005687 !important;
    }
  }
  // .headline-wrapper {
  //   background-color: none;
  // }

  // #header-group {
  //   position: relative;
  // }

  // #head-scroller {
  //   top: 30% !important;
  // }

  // :global(.scroller-video-foreground) {
  //   text-align: center;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  // }

  // :global(.scroller-video-foreground p) {
  //   text-align: center;
  // }
</style>
